import React from "react"
import { AgentOption } from "@/hooks/useAgentOptions"
import { Gender } from "@/types/__generated__/union-types"

type ExtraOption = { heading?: string; last?: boolean }
export type GenderSkillOption = { kind: "Gender"; label: string; value: Gender; icon?: React.JSX.Element } & ExtraOption
export type AgentOrGenderSkillOption = (AgentOption & ExtraOption) | GenderSkillOption

const allAgentsHeading = "patient.information.allAgents"
const favoriteAgentsHeading = "patient.information.favoriteMedgateDoctors"

export const handleFilterOptions = (
  genderOptions: GenderSkillOption[],
  agentOptions: AgentOption[],
  searchText: string,
  favoriteAgents?: readonly string[],
) => {
  const hasSearchText = searchText.length >= 3
  const allOptions: AgentOrGenderSkillOption[] = []
  const filteredFavoriteAgents: AgentOrGenderSkillOption[] = []

  const filterWithSearchText = (value: string) => {
    const searchTerms = searchText.trim().toLowerCase().split(" ")
    const label = value.toLowerCase()
    return searchTerms.some((term) => label.includes(term))
  }

  agentOptions.forEach((agent) => {
    const heading = allOptions.length === 0 ? allAgentsHeading : undefined
    let isMatchSearch = true
    if (hasSearchText) {
      isMatchSearch = filterWithSearchText(agent.label)
    }
    if (!isMatchSearch) return

    if (favoriteAgents?.includes(agent.value)) {
      filteredFavoriteAgents.push({ ...agent, kind: "User" })
    } else {
      allOptions.push({ ...agent, kind: "User", heading })
    }
  })

  // add filtered favorite agents to top of list
  allOptions.unshift(
    ...filteredFavoriteAgents.map((fa, idx) => ({
      ...fa,
      heading: idx === 0 ? favoriteAgentsHeading : undefined,
      last: idx === filteredFavoriteAgents.length - 1,
    })),
  )

  // filter gender options
  allOptions.unshift(...(hasSearchText ? genderOptions.filter((g) => filterWithSearchText(g.label)) : genderOptions))

  return allOptions
}
